import { TFunction } from '@lyearn/i18n';
import { BellOutline, CursorOutline } from '@lyearn/icons';

export const getMasqueradeDetailItems = (t: TFunction) => [
  {
    Icon: CursorOutline,
    label: t('Admin:Masquerade.MasqueradeAboutAction'),
  },
  {
    Icon: BellOutline,
    label: t('Admin:Masquerade.MasqueradeAboutNotification'),
  },
];
